import React, { useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import './Transfer.css';

const Transfer= () => {
  const [activeTab, setActiveTab] = useState('internal');
  const [fromAccount, setFromAccount] = useState('Checking ••1234');
  const [toAccount, setToAccount] = useState('');
  const [amount, setAmount] = useState('');
  const [schedule, setSchedule] = useState('now');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [transferSuccess, setTransferSuccess] = useState(false);

  const accounts = [
    { id: 1, name: 'Checking', number: '••1234', balance: 5420.50 },
    { id: 2, name: 'Savings', number: '••5678', balance: 12750.25 },
    { id: 3, name: 'Investment', number: '••9012', balance: 38520.75 }
  ];

  const recentContacts = [
    { id: 1, name: 'Alex Johnson', bank: 'Chase', lastDigits: '4321' },
    { id: 2, name: 'Maria Garcia', bank: 'Bank of America', lastDigits: '8765' },
    { id: 3, name: 'David Kim', bank: 'Wells Fargo', lastDigits: '1098' }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setTransferSuccess(true);
      
      // Reset form after success
      setTimeout(() => {
        setTransferSuccess(false);
        setToAccount('');
        setAmount('');
      }, 3000);
    }, 1500);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setAmount(value);
    }
  };

  return (
    <div className="transfer-page">
      <div className="transfer-container">
        <div className="transfer-header">
          <h1>Transfer Money</h1>
          <p>Move money between your accounts or send to others</p>
        </div>

        <div className="transfer-tabs">
          <button 
            className={activeTab === 'internal' ? 'active' : ''}
            onClick={() => setActiveTab('internal')}
          >
            Between My Accounts
          </button>
          <button 
            className={activeTab === 'external' ? 'active' : ''}
            onClick={() => setActiveTab('external')}
          >
            To Someone Else
          </button>
        </div>

        <form className="transfer-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <label>From Account</label>
            <div className="account-selector">
              <select 
                value={fromAccount} 
                onChange={(e) => setFromAccount(e.target.value)}
              >
                {accounts.map(account => (
                  <option key={account.id} value={`${account.name} ••${account.number}`}>
                    {account.name} ••{account.number} (${account.balance.toLocaleString()})
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-section">
            <label>{activeTab === 'internal' ? 'To Account' : 'Recipient'}</label>
            {activeTab === 'internal' ? (
              <div className="account-selector">
                <select 
                  value={toAccount} 
                  onChange={(e) => setToAccount(e.target.value)}
                  required
                >
                  <option value="">Select account</option>
                  {accounts
                    .filter(account => `${account.name} ••${account.number}` !== fromAccount)
                    .map(account => (
                      <option key={account.id} value={`${account.name} ••${account.number}`}>
                        {account.name} ••{account.number} (${account.balance.toLocaleString()})
                      </option>
                    ))
                  }
                </select>
              </div>
            ) : (
              <div className="recipient-section">
                <input
                  type="text"
                  placeholder="Enter recipient name, email, or phone"
                  value={toAccount}
                  onChange={(e) => setToAccount(e.target.value)}
                  required
                />
                <div className="recent-contacts">
                  <p>Recent recipients</p>
                  <div className="contact-chips">
                    {recentContacts.map(contact => (
                      <div 
                        key={contact.id}
                        className="contact-chip"
                        onClick={() => setToAccount(contact.name)}
                      >
                        <span className="contact-initial">{contact.name.charAt(0)}</span>
                        <div className="contact-info">
                          <span className="contact-name">{contact.name}</span>
                          <span className="contact-details">{contact.bank} ••{contact.lastDigits}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="form-section">
            <label>Amount</label>
            <div className="amount-input">
              <span className="currency-symbol">$</span>
              <input
                type="text"
                placeholder="0.00"
                value={amount}
                onChange={handleAmountChange}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <label>Schedule Transfer</label>
            <div className="schedule-options">
              <label className="radio-option">
                <input
                  type="radio"
                  name="schedule"
                  value="now"
                  checked={schedule === 'now'}
                  onChange={() => setSchedule('now')}
                />
                <span className="radio-custom"></span>
                Transfer now
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="schedule"
                  value="later"
                  checked={schedule === 'later'}
                  onChange={() => setSchedule('later')}
                />
                <span className="radio-custom"></span>
                Schedule for later
              </label>
            </div>

            {schedule === 'later' && (
              <div className="datetime-picker">
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
                <input
                  type="time"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  required
                />
              </div>
            )}
          </div>

          <button 
            type="submit" 
            className={`submit-button ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Processing...' : 'Review Transfer'}
          </button>

          {transferSuccess && (
            <div className="success-message">
              <span className="success-icon"><FiCheckCircle /></span>
              Transfer completed successfully!
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Transfer;